import Home from "./Home";
import Page404 from "./Page404";

export { Home, Page404 };
